import type { MentionCandidate } from './mentionUtils'

export function referenceMentionSections(
  candidates: MentionCandidate[],
  referenceIds: readonly string[] = [],
  query = '',
) {
  const byId = new Map(candidates.map((candidate) => [candidate.id, candidate]))
  const ids = new Set(referenceIds)
  const matches = (candidate: MentionCandidate) =>
    !query ||
    candidate.label.toLowerCase().includes(query.toLowerCase()) ||
    candidate.type.toLowerCase().includes(query.toLowerCase())
  const references = [...ids].flatMap((id) => {
    const candidate = byId.get(id)
    return candidate && matches(candidate) ? [candidate] : []
  })
  const others = candidates.filter(
    (candidate) => !ids.has(candidate.id) && matches(candidate),
  )
  return {
    candidates: [...references, ...others],
    referenceCount: references.length,
    sectioned: referenceIds.some((id) => byId.has(id)),
  }
}
